// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".import-space-modal[data-v-8b63cba8]{width:250px;max-width:250px}", ""]);
// Exports
module.exports = exports;
